import { APP_NAME } from '@amo/core/constants/constants.js'

const localStorage = window.localStorage;

export const localStorageAMO = JSON.parse(localStorage.getItem(APP_NAME));
